import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RequirementService } from 'src/app/services/requirement.service';
@Component({
    selector: 'app-batch-delete-requirement',
    templateUrl: './batch-delete-requirement.component.html',
    styleUrls: ['./batch-delete-requirement.component.scss'],
    standalone: false
})
export class BatchDeleteRequirementComponent implements OnInit {
	@Output() deleteFile = new EventEmitter<boolean>();
	@Input() requirementIds: Array<number>;
	@Input () title: string;
	@Input () message: number = -1;
	loading: boolean = false;
  constructor(
		public activeModal: NgbActiveModal,
		public _requirements: RequirementService,
	) { }

  ngOnInit() {
	}

	confirmDelete(event) {
		if (event) {
			this.loading = true;
      this.deleteFile.emit(true);
		}
	}
}
